/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiBodyContentElement,
  ApiBodyContentElementFromJSON,
  ApiBodyContentElementFromJSONTyped,
  ApiBodyContentElementToJSON,
} from './ApiBodyContentElement';

/**
 *
 * @export
 * @interface ApiBodyContent
 */
export interface ApiBodyContent {
  /**
   *
   * @type {string}
   * @memberof ApiBodyContent
   */
  type: ApiBodyContentTypeEnum;
  /**
   *
   * @type {ApiBodyContentElement}
   * @memberof ApiBodyContent
   */
  element: ApiBodyContentElement;
}

/**
 * @export
 */
export const ApiBodyContentTypeEnum = {
  AvatarParty: 'avatarParty',
  Config: 'config',
  Heading: 'heading',
  EmphasizedTitle: 'emphasizedTitle',
  EmphasizedHeading: 'emphasizedHeading',
  SubHeading: 'subHeading',
  Image: 'image',
  Buttons: 'buttons',
  ByLine: 'byLine',
  List: 'list',
  Eyebrow: 'eyebrow',
  TextCenter: 'textCenter',
  Lando: 'lando',
  TitleCenter: 'titleCenter',
  Title: 'title',
  Text: 'text',
  PetForm: 'petForm',
} as const;
export type ApiBodyContentTypeEnum = typeof ApiBodyContentTypeEnum[keyof typeof ApiBodyContentTypeEnum];

export function ApiBodyContentFromJSON(json: any): ApiBodyContent {
  return ApiBodyContentFromJSONTyped(json, false);
}

export function ApiBodyContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiBodyContent {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    type: json['type'],
    element: ApiBodyContentElementFromJSON(json['element']),
  };
}

export function ApiBodyContentToJSON(value?: ApiBodyContent | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    type: value.type,
    element: ApiBodyContentElementToJSON(value.element),
  };
}
